export const ADMISSION_DATA = "admission-data";
export const CURRENT_STEP = "current-step";
export const CURRENT_USER_DATA = "current-user-data";
export const USER_TYPE = "user-type";
export const USER_TOKEN = "token";
export const USERS_DATA = "users-data";
export const ADMIN_USER_DATA = "admin-user-data";
export const ACTIVE_ACADEMIC_YEAR = "active-academic-year";
